// extracted by mini-css-extract-plugin
export default {"pageRoot":"LandFindingPage_pageRoot__4ht8o","pageContent":"LandFindingPage_pageContent__To1HL"};